import { useState } from "react";
import { TextInput, TextInputProps, View, Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useCSSVariable } from "uniwind";
import { cn } from "@/shared/lib/utils";

type SearchInputProps = Omit<TextInputProps, "onChangeText" | "onChange"> & {
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
  onClear?: () => void;
};

export function SearchInput({
  value,
  onChange,
  placeholder = "Pesquisar",
  className,
  containerClassName,
  onClear,
  ...rest
}: SearchInputProps) {
  const [isFocused, setIsFocused] = useState(false);
  const [brand, border, mutedForeground] = useCSSVariable([
    "--color-brand",
    "--color-border",
    "--color-muted-foreground",
  ]) as [string, string, string];

  const handleClear = () => {
    onChange("");
    onClear?.();
  };

  return (
    <View className={cn("relative", containerClassName)}>
      <TextInput
        value={value}
        onChangeText={onChange}
        placeholder={placeholder}
        placeholderTextColor={mutedForeground}
        className={cn(
          "bg-card text-foreground rounded-2xl px-4 py-2 pr-10",
          className
        )}
        style={{
          borderColor: isFocused ? brand : border,
          borderWidth: 1.5,
          fontSize: 16,
          shadowColor: brand,
          shadowOpacity: isFocused ? 0.25 : 0,
          shadowRadius: 8,
          shadowOffset: { width: 0, height: 0 },
        }}
        autoCapitalize="none"
        clearButtonMode="while-editing"
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        {...rest}
      />
      <View className="absolute top-0 right-4 bottom-0 flex-row items-center justify-center">
        {value ? (
          <Pressable onPress={handleClear} className="p-1">
            <Ionicons
              name="close"
              size={20}
              color={isFocused ? brand : mutedForeground}
            />
          </Pressable>
        ) : (
          <Ionicons
            name="search"
            size={20}
            color={isFocused ? brand : mutedForeground}
          />
        )}
      </View>
    </View>
  );
}
